import type { IntegrationSummary, IntegrationStatus } from '@/features/integrations/types'

// Combines the 'outlook' and 'outlook_calendar' IntegrationSummary rows (both
// already returned by GET /integrations) into one card's worth of status —
// mirrors google-workspace/lib/status.ts's combineGoogleWorkspaceStatus.
export function combineOutlookWorkspaceStatus(
  outlook: IntegrationSummary | undefined,
  outlookCalendar: IntegrationSummary | undefined,
): IntegrationStatus {
  if (!outlook || !outlookCalendar) return 'not_configured'
  if (outlook.status === 'not_configured' || outlookCalendar.status === 'not_configured') return 'not_configured'
  if (outlook.status === 'active' && outlookCalendar.status === 'active') return 'active'
  if (outlook.status === 'disconnected' && outlookCalendar.status === 'disconnected') return 'disconnected'
  // Any other combination (one connected / one not, or either invalid) means
  // the combined connection isn't fully usable — reconnecting fixes both legs.
  return 'invalid'
}
